import { createApp, defineAsyncComponent } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { createPinia } from "pinia";
import { MotionPlugin } from '@vueuse/motion'
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { createHead } from "@vueuse/head";
// import { registerComponents } from "./utils/components.js";

import { API } from "./api/api";
import { createApolloProvider } from "@vue/apollo-option";
import Toast from "vue-toastification";
// Import the CSS or use your own!
// import VueExcelEditor from "vue3-excel-editor";
// import { Vue3ProgressPlugin } from "@marcoschulte/vue3-progress";
import VueGtag from "vue-gtag";
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
import Intercom from "@intercom/messenger-js-sdk";


const { VITE_INTERCOM_APP_ID } = import.meta.env;

Intercom({
  app_id: VITE_INTERCOM_APP_ID,
});
// import Vue3SimpleHtml2pdf from "vue3-simple-html2pdf";
// import VueEasyLightbox from "vue-easy-lightbox";
// import Ripple from "primevue/ripple";
// import Tooltip from "primevue/tooltip";

// // import DataTable from "primevue/datatable";
// import InputText from "primevue/inputtext";
// import Select from "primevue/select";
// import Column from "primevue/column";

import "primeicons/primeicons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/styles/tailwind.css";
import "vue-toastification/dist/index.css";
import "./styles/app.css"; // Here

import firebaseMessaging from "./utils/firebase.js";

// const ProgressBar = defineAsyncComponent(() => import("primevue/progressbar"));
// const Tag = defineAsyncComponent(() => import("primevue/tag"));
// const Drawer = defineAsyncComponent(() => import("primevue/drawer"));
// const Carousel = defineAsyncComponent(() => import("primevue/carousel"));

const app = createApp(App);

app.config.globalProperties.$messaging = firebaseMessaging;

const apolloProvider = createApolloProvider({
  defaultClient: API,
});
app.config.productionTip = false;

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const head = createHead();
app.use(head);
app.use(router);

// Export head instance for use in router
export { head };
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: false || "none",
    },
  },
  ripple: true,
});
app.use(Toast);
app.use(pinia);
app.use(MotionPlugin)
app.use(apolloProvider);
app.use(
  VueGtag,
  {
    appName: "myeazipay staging",
    pageTrackerScreenviewEnabled: true,
    config: { id: "G-FV9HDMCJ2H" },
  },
  router
);

// app.use(Vue3ProgressPlugin);



// registerComponents(app);

app.mount("#app");

// Trigger prerender event after app is mounted and router is ready
router.isReady().then(() => {
  // Wait a short time for Vue to finish initial rendering
  setTimeout(() => {
    document.dispatchEvent(new Event("render-event"));
  }, 300);
});


